<template>
  <div class="table-container">
    <!-- mobile / tablet -->
      <b-container class="viz-container">
        <div class="horizontal-line"/>
        <!-- titolo sottotitolo -->
        <b-row class="table-header">
          <b-col>
            <div class="title">
              <span v-text="content.nota.title"/>
            </div>
            <div class="description">
              <span v-text="content.nota.description"/>
            </div>
          </b-col>
        </b-row>
        <!-- table -->
        <b-row class="table-content">
          <b-col
            v-for="(column, c) in this.content.columns"
            :key="c"
            :class="['box-column', column.column_type]"
            :cols="(c==0) ? 4 : 0"
          >
            <div
              class="row"
              v-for="(row, r) in column.rows"
              :key="r"
              v-html="row"
            />
          </b-col>
        </b-row>
        <!-- source -->
        <b-row>
          <b-col>
            <div class="source">
              <span v-html="content.nota.source"/>
            </div>
          </b-col>
        </b-row>
      </b-container>
  </div>
</template>

<script>
import gsap from 'gsap'
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
export default {
  name: 'Table',
  props: ["content"],
  components: {
  },
  data: function(){
    return {
      tl: null
    }
  },
  mounted() {
    gsap.registerPlugin(ScrollTrigger);
    gsap.set(this.$el.querySelector('.horizontal-line'),{xPercent: -100});
    gsap.set(this.$el.querySelectorAll('.box-column'),{y: 100, opacity:0, scale: 1.05});
    this.scrollAnimation();
  },
  methods: {
    scrollAnimation() {
      this.tl = gsap.timeline({
        scrollTrigger: {
          trigger: this.$el,
          start: "10% 55%",
          end: "+=0",
          markers: false,
          scrub: false,
          pin: false,
        }
      });
      this.tl.to(this.$el.querySelector('.horizontal-line'), {xPercent: 0, duration: 1, ease: "power2.out"})
      this.tl.to(this.$el.querySelectorAll('.box-column'), {y: 0, opacity: 1, scale: 1, duration: 2, stagger: .35, ease: "back.out(1.5)"})
    }
  }
};
</script>

<!-- Use preprocessors via the lang attribute! e.g. <style lang="scss"> -->
<style lang="scss" scoped>
@import "@/assets/scss/colors.scss";
@import "@/assets/scss/bper-fonts.scss";

.table-container{
  padding-bottom: 40px;
  .viz-container{
    .horizontal-line{
      position: absolute;
      width: 100%;
      height: 1px;
      left: 0px;
      border-bottom: 1px dashed $bper-verde-scuro;
      margin-top: 120px;
    }
    .table-header{
      .title{
        position: relative;
        font-family: KievitOT;
        font-weight: 500;
        font-size: 14px;
        margin-bottom: 18px;
        line-height: 36px;
        span{
          color: $bper-arancione;
          background-color: rgba($bper-arancione,.25);
          border: 1px solid $bper-arancione;
          border-radius: 3px;
          padding: 8px;
        }
      }
      .description{
        font-family: KievitOT;
        font-size: 14px;
        line-height: 18px;
        margin-bottom: 32px;
        span{
          color: $bper-bianco;
          background-color: $bper-verde-scuro;
          border-radius: 3px;
          padding: 4px;
        }
      }
    }
    .table-content{
      display: flex;
      flex-direction: row;
      padding: 0px 15px;
      .box-column{
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        margin-right: 8px;
        border-radius: 3px;
        box-shadow: $bper-dropdown-shadow;
        background-color: $bper-bianco;
        border: .75px solid $bper-verde-scuro;
        .row{
          position: relative;
          min-height: 32px;
          padding-left: 8px;
          padding-right: 12px;
          padding-bottom: 12px;
          text-align: left;
          @include table-value-row;
          &:first-child{
            padding-bottom: 8px;
          }
        }
        &:last-child{
          margin-right: 0px;
        }
      }
      .orange{
        .row{
          font-size: 14px;
          line-height: 17px;
          &:first-child{
            color: $bper-arancione;
            @include table-value-row-bold;
          }
        }
      }
      .white{
        .row{
          &:first-child{
            color: $bper-verde-chiaro;
            @include table-value-row-bold;
          }
        }
      }
      .green{
        border: none;
        background-color: $bper-verde-scuro;
        .row{
          color: $bper-bianco;
          &:first-child{
            color: $bper-verde-chiaro;
            @include table-value-row-bold;
          }
        }
      }
    }
  }
  .source{
    font-family: KievitOT;
    color: $bper-verde-scuro;
    line-height: 18px;
    margin-top: 20px;
    span{
      border-radius: 3px;
      border: 1px solid $bper-verde-scuro;
      padding: 4px;
      font-size: 12px;
    }
  }
}

@media only screen 
  and (min-device-width: 1250px)
  and (orientation: landscape)  {
    .table-container{
      .viz-container{
        .horizontal-line{
          padding-top: 23px;
        }
        .table-header{
          .title{
            font-size: 18px;
          }
          .description{
            font-size: 16px;
          }
        }
        .table-content{
          .box-column{
            padding-top: 8px;
            padding-bottom: 8px;
            padding-left: 32px;
            margin-right: 72px;
            .row{
              font-size: 20px;
              padding-bottom: 18px;
            }
            &:last-child{
              margin-right: 0px;
            }
          }
          .orange{
            .row{
              line-height: 21px;
            }
          }
        }
      }
    }

  }
</style>